import { useCollection } from '@hb/react'
import {
  adminPracticeContractsCollection,
  FieldMap,
  FieldTypes,
  PracticeContractTemplate,
} from '@hb/shared'
import { useCallback, useMemo, useState } from 'react'
import { getCollectionRef } from '../../../../backend/db/utils/collections'
import { deletePracticeContractTemplate } from '../../../../backend/functions/practiceContracts'
import { CollectionListEdit } from '../../../forms'
import { DefaultModal } from '../../../Modals'
import { TemplateEditorModal } from '../../TemplateEditModal'
import { PracticeContractPreview } from '../PracticeContractPreview'
import { AddPracticeContract } from './AddPracticeContract'

const practiceContractField: FieldMap = {
  name: 'Practice Contract',
  children: {
    name: {
      type: FieldTypes.TEXT,
      placeholder: 'Practice Contract Name',
    },
  },
}

const NewPracticeContractModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => (
  <DefaultModal
    overlayHeader
    isOpen={isOpen}
    onClose={onClose}
    render={() => <AddPracticeContract onClose={onClose} />}
  />
)

export const AdminPracticeContractsView = ({ onClose }: { onClose?: () => void }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null)
  const [creatingNew, setCreatingNew] = useState(false)
  const ref = useMemo(() => getCollectionRef(adminPracticeContractsCollection), [])
  const { items: templates = [] } = useCollection(adminPracticeContractsCollection) ?? {}

  const handleDelete = useCallback(async (id: string) => {
    await deletePracticeContractTemplate({ templateId: id })
  }, [])

  return (
    <>
      <CollectionListEdit<PracticeContractTemplate>
        ItemPreview={({ value }) => (
          <PracticeContractPreview
            onOpenTemplate={() => setSelectedTemplateId(value.id)}
            template={value}
            key={value.id}
          />
        )}
        collectionRef={ref}
        onNewItemClick={() => setCreatingNew(true)}
        itemField={practiceContractField}
        getItemTitle={item => item.name}
        noItemEdit
        onDeleteItem={handleDelete}
        itemName="Practice Contract"
        listName="Practice Contracts"
        value={templates}
        onClose={onClose}
      />
      {selectedTemplateId ? (
        <TemplateEditorModal
          templateType="practiceContract"
          templatePracticeId={null}
          templateId={selectedTemplateId}
          isOpen
          onClose={() => setSelectedTemplateId(null)}
        />
      ) : null}
      {creatingNew ? (
        <NewPracticeContractModal isOpen={creatingNew} onClose={() => setCreatingNew(false)} />
      ) : null}
    </>
  )
}

export const AdminPracticeContractsModal = ({ onClose }: { onClose: () => void }) => (
  <DefaultModal
    isOpen
    size="3xl"
    overlayHeader
    closeDisabled
    onClose={onClose}
    render={() => <AdminPracticeContractsView onClose={onClose} />}
  />
)
